import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { NewsWidget, NewsWidgetComponent } from 'app/views/presentations/widgets/news/news.widget';
import { WidgetWrapperModule } from 'app/views/presentations/widgets/widgetWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        WidgetWrapperModule.wrapWidget(NewsWidget)
    ],
    declarations: [
        NewsWidgetComponent
    ],
    entryComponents: [
        NewsWidgetComponent
    ]
})
export class NewsWidgetModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/news/news.module.ts